import axios from "axios";
import { getCookie } from "../../../../helpers/common";

import { toast } from "react-toastify";
import { getEnv } from "helpers/environment";

const makeRequest = async (data) => {
  const accessToken = getCookie("accessToken");

  try {
    const response = await axios({
      method: "post",
      url: getEnv("PAYMENT_GATEWAY"),
      maxBodyLength: Infinity,
      data: data,
      headers: {
        "Content-Type": "application/json",
        "Apollo-Require-Preflight": true,
        Authorization: "Bearer " + accessToken,
        withCredentials: true
      }
    });
    return response?.data?.data;
  } catch (error) {
    console.log(error);
    if (error.response) {
      toast.error("Oops! Something went wrong on our end. We're working to fix it.");
    }
    return { error: error.message };
  }
};
const insertQuery = async (data) => {
  return makeRequest(data);
};

const updateQuery = async (data) => {
  return makeRequest(data);
};

const getQuery = async (data) => {
  return makeRequest(data);
};
const deleteQuery = async (data) => {
  return makeRequest(data);
};

export { getQuery, insertQuery, updateQuery, deleteQuery };
